import React from "react";

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="simb-footer">
            <p>© {currentYear} SIMB. All rights reserved. Version 1.0.1</p>
        </footer>
    );
};

export default Footer;